import { render, staticRenderFns } from "./CommesaDrawer.vue?vue&type=template&id=38a86d78&scoped=true&"
import script from "./CommesaDrawer.vue?vue&type=script&lang=js&"
export * from "./CommesaDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CommesaDrawer.vue?vue&type=style&index=0&id=38a86d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a86d78",
  null
  
)

export default component.exports